<template>
  <notification-drop-down-list-item
    :title="title"
    icon="UploadCloudIcon"
    :color="color"
    @click-ntf="$emit('redirect', to)"
  >
    <small>
      {{ message }}
      <br>
      <strong>
        <router-link
          :to="to"
          class="link-plain">
          {{  $t('ViewAll') }}
        </router-link>
      </strong>
    </small>
  </notification-drop-down-list-item>
</template>

<script>
// Components
import NotificationDropDownListItem from '@/layouts/components/navbar/components/notifications/NotificationDropDownListItem.vue';

// Mixins
import notificationItemMixin from '@/layouts/components/navbar/components/notifications/mixins/notification-item.mixin';

export default {
  name: 'InboundSmsNotification',
  i18n: {
    messages: {
      en: {
        TitleSuccess: 'Import complete',
        TitleFailed: 'Import failed',
        MsgSuccess: 'Your {entity} import completed successfully.',
        MsgFailed: 'Your {entity} import could not be completed.',
        ViewAll: 'View import report',
      },
    },
  },
  components: {
    NotificationDropDownListItem,
  },
  mixins: [notificationItemMixin],
  computed: {
    importId() {
      return this.payload && (this.payload.id || this.payload._id)
        ? this.payload.id || this.payload._id
        : '';
    },
    status() {
      return this.payload && this.payload.status
        ? this.payload.status
        : '';
    },
    entityName() {
      return this.payload && this.payload.entityName
        ? this.payload.entityName
        : '';
    },
    entityMapped() {
      return Object.values(this.$enums.Entity).find(
        (entity) => entity.toLowerCase() === this.entityName.toLowerCase()
          .replace(' ', '')
          .replace('-', ''),
      );
    },
    entityDisplay() {
      const name = this.$tc(`$Entities.${this.entityMapped}`, 2);
      return name ? name.toLowerCase() : '';
    },
    title() {
      return this.status === this.$enums.Import.STATUS.COMPLETED
        ? this.$t('TitleSuccess', { entity: this.entityDisplay })
        : this.$t('TitleFailed', { entity: this.entityDisplay });
    },
    message() {
      return this.status === this.$enums.Import.STATUS.COMPLETED
        ? this.$t('MsgSuccess', { entity: this.entityDisplay })
        : this.$t('MsgFailed', { entity: this.entityDisplay });
    },
    color() {
      return this.status === this.$enums.Import.STATUS.COMPLETED
        ? 'success'
        : 'danger';
    },
    to() {
      const queryParam = 'importReport';

      switch (this.entityMapped) {
        case this.$enums.Entity.TAG:
          return `/tags?${queryParam}=${this.importId}`;

        case this.$enums.Entity.CONTACT:
          return `/contacts?${queryParam}=${this.importId}`;

        case this.$enums.Entity.SMS_TEMPLATE:
          return `/sms-templates?${queryParam}=${this.importId}`;

        default:
          return '/';
      }
    },
  },
};
</script>

<style scoped>

</style>
